import { CurrencyOptionResource, Id, ImageResource } from "@dgs/core";

export enum HotelStayStatus {
	INQUIRY = "INQUIRY",
	BOOKING = "BOOKING",
	CONFLICT = "CONFLICT",
	CANCELLATION_REQUESTED = "CANCELLATION_REQUESTED",
}

export enum WayOfBooking {
	INQUIRY = "inquiry",
	BOOKING = "booking",
}

export interface StayConfigurationResource {
	hotelStayTypeId: number;
	earliestCombinedCheckIn: string;
	latestCombinedCheckOut: string;
	earliestCheckIn: string;
	latestCheckOut: string;
	prefillCheckInCheckOutInFrontend: boolean;
	enableQuotaWarning: boolean;
	minStayPeriods: number;
	maxStayPeriods: number;
	maxNights: number;
	isPreferredHotelSelectable: boolean;
	isPreferredRoomTypeSelectable: boolean;
	showRoomCapacityInFrontend: boolean;
	wayOfBooking: WayOfBooking;
	allowAdditionalPersons: boolean;
	allowRemarkByGuest: boolean;
}

export interface HotelRoomPriceResource {
	min: number;
	max: number;
	currency: CurrencyOptionResource;
}

export interface HotelRoomResource {
	id: number;
	name: string;
	capacity: number;
	price: HotelRoomPriceResource | null;
	canBeRequested: boolean;
}

export interface HotelResource {
	id: number;
	name: string;
	street: string | null;
	zip: string | null;
	city: string | null;
	country: string | null;
	url: string | null;
	infoPageId: number | null;
	rooms: HotelRoomResource[];
	image: ImageResource | null;
}

export interface HotelStayFormValues {
	id: Id | null;
	status: HotelStayStatus;
	checkIn: string;
	checkOut: string;
	requestedHotelId: number | null;
	requestedRoomTypeId: number | null;
	remarkByGuest: string | null;
	cancellationRequested: boolean;
	additionalPersonsText: string | null;
	additionalPersonsEnabled: boolean;
	mainStay: HotelMainStayResource | null;
}

export interface HotelsByDateRangeRequest {
	checkIn: string;
	checkOut: string;
	guestId: Id | null;
}

export interface HotelSectionFormValues {
	hotelStays: HotelStayFormValues[];
}

export interface HotelStayConfigurationRequest {
	guestId: Id | null;
}

interface HotelSummaryStayRequest {
	checkIn: string;
	checkOut: string;
	requestedHotelId: Id | null;
	requestedRoomTypeId: Id | null;
}

export interface HotelSummaryRequest {
	guestId: Id | null;
	hotelStays: HotelSummaryStayRequest[];
}

export interface HotelSummaryPriceResource {
	date: string;
	price: number | null;
}

export interface HotelSummaryResource {
	checkIn: string;
	checkOut: string;
	status: HotelStayStatus;
	hotelName: string | null;
	roomTypeName: string | null;
	currency: CurrencyOptionResource | null;
	prices: HotelSummaryPriceResource[];
	totalPrice: number;
	stayConfiguration: StayConfigurationResource;
	cancellationRequested?: boolean;
}

export interface HotelMainStayResource {
	id: Id;
	status: HotelStayStatus;
	checkIn: string;
	checkOut: string;
}
